<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <div class="text-center mt-sm-5 mb-4 text-dark">
        <div>
          <a routerLink="" class="d-inline-block auth-logo">
            <img src="assets/images/logo-dark.svg" alt="" height="40">
          </a>
        </div>
        <p class="mt-3 fs-15 fw-medium">{{'MESSAGES.GET_YOUR_DETAILED_CAHSH' | translate}}</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-lg-10">
      <!-- English T & C -->
      @if (_translate.currentLang == 'en') {
        <div class="card">
          <div class="bg-soft-warning position-relative">
            <div class="card-body p-5">
              <div class="text-center">
                <h3>Term &amp; Conditions</h3>
                <p class="mb-0 text-muted">Last update: 1 June, 2023</p>
              </div>
            </div>
            <div class="shape">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs" width="1440" height="60" preserveAspectRatio="none"
                viewBox="0 0 1440 60">
                <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                  <path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                  style="fill: var(--vz-card-bg-custom);"></path>
                </g>
                <defs>
                  <mask id="SvgjsMask1001">
                    <rect width="1440" height="60" fill="#ffffff"></rect>
                  </mask>
                </defs>
              </svg>
            </div>
          </div>
          <div class="card-body p-4">
            <div>
              <h5>General Terms of Use</h5>
              <p class="text-decoration-underline fw-bold">Introduction:</p>
              <p class="text-muted">Al Omla Al Hadesa for financial solutions (AOH), a registered company in
                the Kingdom of Saudi Arabia (KSA) with commercial registration number 1010843917 (the
                Company, we or us), offers Deben as a service that enables business entities to connect and
                integrate with their different banks to obtain financial information and perform other
              digital services.</p>
              <p class="text-muted">For inquiries, please contact us via email at info&#64;deben.io or call us
                at
              our telephone number: +966 50 935 8075.</p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">Acceptance and Confirmations:</p>
              <p>By using Deben, you agree to the following terms and conditions:</p>
              <ul class="text-muted vstack gap-2">
                <li>
                  You have read, understood, and agreed to be bound by Deben's Terms of Use, Client
                  Agreement, and Privacy Policy.
                </li>
                <li>
                  You agree to receive information, including notices of amendments to these Terms,
                  through communications posted on Deben or other means as set out in the Privacy Policy.
                </li>
                <li>
                  The person accessing Deben using the relevant login details created on Deben for your
                  Account has the necessary authority to act on behalf of any legal entity for which the
                  Account was created.
                </li>
                <li>
                  You agree to receive communications and the delivery of the Terms and/or any
                  agreements between us or changes to the Terms via electronic media, including electronic
                  messaging, website postings, email, or other electronic means.
                </li>
                <li>
                  You agree that the electronic delivery of notices, policies, and records of
                  transactions initiated or completed through Deben and/or in relation thereto, as well as
                  any digitally enabled signatures, shall be treated as satisfying any legal requirements
                  that a communication should be 'signed' and 'in writing.' Accordingly, any such
                  documents that are delivered to you electronically are deemed to be 'in writing.'
                </li>
                <li>
                  You waive the right to claim that any electronic confirmation, agreement, validation,
                  or registration is invalid due to lack of any physical signature or attestation.
                </li>
                <p class="text-black">
                  If you do not agree to these terms and conditions, you are not authorized to use Deben.
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">The Applicability of the Privacy Policy and Client
                Agreement:
              </p>
              <ul class="text-muted vstack gap-2">
                <p>In addition to the Terms of Use, the following additional terms apply to your use of
                  Deben:
                </p>
                <li>
                  · Privacy Policy: Deben's Privacy Policy describes how we process any personal data we
                  collect from you or that you provide to us. By using Deben, you acknowledge and agree to
                  our Privacy Policy and processing activities, and you represent and warrant that all
                  data provided by you is accurate.
                </li>
                <li>
                  · Client Agreement: The Client Agreement outlines the terms applicable to the specific
                  services provided to you through Deben from time to time. By using Deben, you consent to
                  the disclaimers in the Client Agreement, acknowledge receipt of the key information, and
                  agree to use Deben in accordance with those terms.
                </li>
              </ul>
              <p class="text-black">
                In the event of any inconsistency between the Terms, Privacy Policy, and Client Agreement,
                the provisions of your Client Agreement shall prevail.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Modification of Terms and Conditions:
              </p>
              <p class="text-muted">
                We reserve the right to amend these Terms at any time for compliance with applicable laws
                and regulations, or for operational upgrades or changes to Deben. You may receive notice of
                such changes through Deben, or via your registered email, and/or on Deben at least thirty
                (30) days prior to the implementation of such changes.
              </p>
              <p class="text-muted">
                You acknowledge that any notice of amendments communicated to you shall be received by you
                from the date of such communication. By using Deben after receiving notice of any amendments
                to these Terms, you agree to be bound by such amendments.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Right to Modify or Discontinue Features:
              </p>
              <p class="text-muted">
                We reserve the right to add, modify, or discontinue any feature, functionality, or tool
                within Deben at its discretion and without prior notice. However, if we make any material
                adverse change to the essential features of Deben, we will notify registered users by
                publishing a notice on Deben or by email.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Right Suspend or Withdraw Deben:
              </p>
              <p class="text-muted">
                Al Omla Al Hadesa (AOH) shall make every reasonable effort to provide its services to users.
                However, we cannot guarantee that its services or any content on its platform will always be
                available, uninterrupted, or free from errors. We reserve the right to suspend, withdraw, or
                restrict the availability of all or any part of its platform for business or operational
                reasons.
              </p>
              <p class="text-muted">
                In the event that Deben suspends its services for a substantial period of time or withdraws
                any part of its core functionality, we shall provide notice to registered users through an
                announcement posted on its platform or via email. Such suspension or withdrawal shall not
                affect users' ability to exercise their rights under applicable data protection laws as
                stated in Deben's Privacy Policy.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Account Creation and Security:
              </p>
              <p class="text-muted">
                To use the services offered on Deben, you must create an account. As part of this process,
                you may be provided with a user identification code, password, or other confidential
                information. You are responsible for maintaining the confidentiality of your account details
                and any user identification code, password, or other security information associated with
                your account. You must not disclose your account details or any user identification code to
                any third party, and you shall adopt adequate security measures to prevent third-party
                access to your login details and other security information.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Technical Requirements:
              </p>
              <ul class="text-muted vstack gap-2">
                <p class="text-black">
                  You are responsible for maintaining the necessary technological capability to access
                  Deben
                  and use its functionality. Specifically:
                </p>
                <li>
                  Access Requirements: You must have an active Deben profile that complies with the
                  technical requirements set out in the support page to create an account and access or
                  use the functionality of Deben.
                </li>
                <li>
                  Irreversible Transactions/Messages: Some transactions or messages sent from one
                  account to another may be irreversible once the transaction or message details have been
                  submitted to Deben. You acknowledge and agree that Al Omla Al Hadesa (AOH) may not be
                  able to assist you in cancelling or modifying your transaction or message details. You
                  are solely responsible for any user errors resulting in unintended transactions or
                  messages, such as mistyped transaction or message instructions.
                </li>
                <li>
                  · No Support Guarantee and Usage Risk: Al Omla Al Hadesa (AOH) does not guarantee
                  technical or user support for Deben. You acknowledge and agree that your use of Deben is
                  at your own risk. Al Omla Al Hadesa (AOH) will make reasonable efforts to provide
                  support but may not be able to assist or resolve any technical issues, including
                  recovery of any lost or inaccessible user details or assets.
                </li>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                You agree and acknowledge that:
              </p>
              <ul class="text-muted vstack gap-2">
                <p class="text-black">
                  The username/ID and password issued by us for the purpose of accessing Deben and related
                  services, as well as all other login and access information provided, are confidential
                  and
                  must only be used by you. You shall not disclose your login details to any third party,
                  and
                  you shall take appropriate measures to prevent unauthorized access to your Account.
                </p>
                <li>
                  You shall choose strong, unique passwords and avoid using easily guessable numbers or
                  passwords, such as birthdays or phone numbers.
                </li>
                <li>
                  You shall be responsible for any orders, confirmations, notices, and information given
                  through the use of your login details, and any items received in this manner by us shall
                  be deemed to have been given by you.
                </li>
                <li>
                  You have an exclusive and non-assignable right to use and access the Account assigned
                  to you in Deben, and you shall ensure that no other third party gains access to your
                  Account.
                </li>
                <li>
                  Frequent access and logins to the Account via different IP addresses from different
                  countries and/or via the use of VPN may lead us to reasonably believe that these Terms
                  have been breached.
                </li>
                <p class="text-black">
                  We have the right to disable any user identification code or password (and your
                  Account), whether chosen by you or allocated by us, at any time, if we believe in our
                  reasonable opinion that you have failed to comply with any of the provisions of these
                  Terms.
                </p>
                <p class="text-black">
                  Your IT equipment, operating system, and internet connection must comply with the
                  technical requirements of Deben. You shall enter your username/ID and password when
                  logging on to Deben.
                </p>
                <p class="text-black">
                  If you become aware of any unauthorized access to your Account or suspect any
                  unauthorized or irregular transaction, you shall promptly notify us by emailing at
                  support&#64;deben.io
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Deben’s Materials Usage:
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  Ownership: The intellectual property rights in Deben, including all published
                  material, are owned or licensed by us. These works are protected by copyright laws and
                  treaties worldwide, and all rights are reserved.
                </li>
                <li>
                  Limited Permission to Use: You may print or download extracts of any page(s) from
                  Deben for your business use, provided that it is not explicitly prohibited in these
                  Terms, the Privacy Policy, or the Client Agreement.
                </li>
                <li>
                  Modifications Prohibited: Modifying printed or digital copies of any material you have
                  printed or downloaded is not allowed without obtaining our prior written consent. You
                  must not use any illustrations, photographs, video or audio sequences, or graphics
                  separately from any accompanying text.
                </li>
                <li>
                  Commercial Use Prohibited: You must not use any part of the content on Deben for
                  commercial purposes without obtaining a license from us. When using personal data, you
                  must comply with our Privacy Policy and your obligations under applicable data
                  protection laws and regulations.
                </li>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Disclaimer of Liability:
              </p>
              <p class="text-muted">
                The information on Deben is provided for general information purposes only and is not
                intended to be relied upon as a substitute for professional advice. We make no
                representations or warranties, whether express or implied, about the accuracy, completeness,
                or suitability of the information on Deben for any particular purpose.
              </p>
              <p class="text-muted">
                The information on Deben is based on information provided to us by third parties, and we do
                not independently verify this information. We make reasonable efforts to update the
                information on Deben, but we cannot guarantee that it is always accurate, complete, or up to
                date.
              </p>
              <p class="text-muted">
                You should not fully rely on information received from Deben without seeking independent
                professional advice. You should not take any action based on the information on Deben
                without first seeking independent professional advice.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Third-Party Links
              </p>
              <p class="text-muted">
                Deben may contain links to third-party websites and resources. These links are provided for
                informational purposes only, and we do not have any responsibility for any content on such
                third-party sites. We do not review or approve third-party sites or their content, and we do
                not endorse or guarantee the products or services offered on those sites.
              </p>
              <p class="text-muted">
                We have no control over the contents of those sites or resources, and we accept no liability
                for any content or loss caused as a result of using such third-party sites. We do not
                warrant that such links work or are up to date.
              </p>
              <p class="text-muted">
                You acknowledge and agree that we are not responsible for any actions or omissions of third
                parties. We are also not responsible for any damage, loss, or expense caused to you or third
                parties as a result of or in relation to any such action or omission.
              </p>
              <p>
                If you decide to access any third-party sites linked to Deben, you do so at your own risk.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Information and Materials on Deben:
              </p>
              <p class="text-muted">
                Deben may include information and materials provided by other users of Deben or third
                parties. Unless otherwise indicated, we have not verified or approved this information or
                these materials. We do not endorse or guarantee the accuracy, completeness, or usefulness of
                any information or materials on Deben.
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  Responsibility for Content: You are responsible for securing and backing up your
                  content. For registered users, we will backup account data for at least 12 months from
                  the date of creation of such data. However, we may delete or otherwise remove your
                  content at any time, for any reason, without notice.
                </li>
                <li>
                  Disclaimer of Liability: We are not responsible for any loss or damage that you may
                  suffer as a result of the use of any information or materials on Deben. This includes,
                  but is not limited to, any loss or damage caused by errors, omissions, or inaccuracies
                  in the information or materials.
                </li>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Indemnification:
              </p>
              <p class="text-muted">
                You agree to indemnify and hold harmless Al Omla Al Hadesa (AOH), its directors, officers,
                employees, and agents from and against all losses, damages, liabilities, costs, and expenses
                (including reasonable attorneys' fees) arising out of or in connection with:
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  Your breach of any of the terms of this Agreement;
                </li>
                <li>
                  Your use of Deben, including any use by any person using your login details or
                  credentials, whether stolen or not; or
                </li>
                <li>
                  Any claim or demand made by any third party arising out of or in connection with your
                  use of Deben.
                </li>
                <p class="text-dark">
                  This indemnity shall remain in effect even after this Agreement is terminated.
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Our Liability for Loss or Damage Incurred by You:
              </p>
              <p class="text-muted">
                We do not exclude or limit our liability to you where such exclusion or limitation would be
                unlawful, such as in cases of fraud.
              </p>
              <p class="text-muted">
                However, we shall not be liable to you in the event of any failure, damage, destruction, or
                formatting of your computer system, mobile phone, or tablet, or if you experience delays or
                any other data integrity problems that result from your hardware configuration or
                mismanagement.
                We are not responsible for any use of Deben by users who are nationals or residents of
                countries where services provided through Deben are prohibited.
              </p>
              <p class="text-muted">
                Our liability to you under these Terms shall be subject to the terms set forth in the
                relevant Client Agreement.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Authorizations:
              </p>
              <p class="text-muted">
                By using Deben, you hereby acknowledge and consent to the terms of the Privacy Policy
                provided to you, which is available on Deben. You also acknowledge and agree that Al Omla Al
                Hadesa (AOH) may disclose all Personal Data that they hold related to you to the relevant
                authorities as required by applicable laws and regulations.
              </p>
              <p class="text-muted">
                You confirm that you understand Deben's Privacy Policy and how they process your Personal
                Data. You understand that they process your personal data where necessary, including:
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  Collecting data related to your use of their service to enable them to provide it to
                  you; and
                </li>
                <li>
                  Analyzing your data for research and product development purposes.
                </li>
                <p class="text-muted">
                  In particular, you understand that by using Deben's services, they may disclose,
                  transfer, or share your Personal Data with other parties, to the extent reasonably
                  necessary, for the purposes of entering into or performing any of their obligations
                  under these Terms and for any purposes connected with the services offered and provided
                  to you by them or any other entity, provided that your data will not be transferred to
                  or stored outside of the Kingdom of Saudi Arabia.
                </p>
                <p class="text-muted">
                  You also authorize Al Omla Al Hadesa (AOH) to use your company names and logos for
                  marketing purposes, and they will give you notice of any such use.
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Fees:
              </p>
              <p class="text-muted">
                We reserve the right to modify its fees (Fees) for using Deben at any time, in accordance
                with the relevant Client Agreement. We will provide you with at least thirty (30) days'
                notice before implementing any such changes.
              </p>
              <p class="text-muted">
                If you do not agree to the new Fees, you may terminate your Account by providing us with
                written notice of termination within thirty (30) days of the date of the notice of the Fee
                change.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Intellectual Property:
              </p>
              <p class="text-muted">
                Deben and all of its content, including but not limited to text, images, audio, video,
                software, and code, are the sole and exclusive property of Al Omla Al Hadesa (AOH). Al Omla
                Al Hadesa (AOH) owns all intellectual property rights in Deben, including but not limited to
                copyrights, trademarks, patents, and trade secrets.
              </p>
              <p class="text-muted">
                The Terms of Service do not grant you any ownership interest in Deben or its content. You
                are only granted a limited license to use Deben in accordance with the Terms of Service.
                This means that you may not:
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  Copy, reproduce, or distribute any part of Deben or its content without the express
                  written permission of Deben.
                </li>
                <li>
                  Modify, adapt, or create derivative works from Deben or its content.
                </li>
                <li>
                  Reverse engineer, decompile, or disassemble Deben or its content.
                </li>
                <li>
                  Use Deben or its content for any commercial purpose.
                </li>
                <li>
                  Upload or post any content to Deben that infringes on the intellectual property rights
                  of others.
                </li>
                <p class="text-muted">
                  We reserve the right to take any action it deems necessary to protect its intellectual
                  property rights, including but not limited to removing any content that infringes on its
                  rights, terminating your account, and pursuing legal action.
                </p>
                <p class="text-muted">
                  You agree that you are solely responsible for any content that you upload or post to
                  Deben. We are not responsible for the accuracy, legality, reliability, appropriateness,
                  originality, or copyright of any content that you upload or post.
                </p>
                <p class="text-muted">
                  Al Omla Al Hadesa (AOH) has the right to refuse to post, remove, edit, or abridge any
                  content for any reason, and to disclose any content as it deems necessary, including
                  without limitation to comply with any applicable law, legal process, or governmental
                  request.
                </p>
                <p class="text-muted">
                  You agree not to obscure or remove any copyright, trademark, or other notices from any
                  of Deben's content.
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Confidentiality:
              </p>
              <p class="text-muted">
                You agree that you will not, at any time after you have been provided a unique user name by
                us, disclose or communicate to any person (except as may be required by law or any legal or
                regulatory authority) any Confidential Information (as defined below). You will also prevent
                the unauthorized publication or disclosure of any Confidential Information, and will only
                use such Confidential Information for use through Deben.
              </p>
              <p class="text-muted">
                Confidential Information means all information in whatever form (including in visual, oral
                or electronic form) relating to us or any service provider or other user of Deben which is
                provided or disclosed through Deben (or to any employees or agents) in connection with the
                use of Deben.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Your Obligations:
              </p>
              <p class="text-black">
                By accepting these Terms, you represent and warrant that:
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  You have the full power and authority to enter into and perform your obligations under
                  these Terms.
                </li>
                <li>
                  You shall comply with all applicable laws, statutes, and regulations at all times.
                </li>
                <li>
                  Any content you submit as part of your use of Deben does not infringe upon the rights
                  of any third party, including intellectual property rights.
                </li>
                <li>
                  Any documents and information submitted during the Account opening process are true,
                  accurate, current, and complete, and you will maintain and update all information as
                  necessary.
                </li>
                <li>
                  You are solely responsible for obtaining any necessary licenses, permits, or
                  certifications for the content that you submit, post, or display on Deben.
                </li>
                <li>
                  You are not subject to any trade restrictions, sanctions, or other legal restrictions
                  of any country, international organization, or other jurisdiction.
                </li>
                <li>
                  If you create an Account or use Deben on behalf of a business entity, you represent
                  that you are authorized to act on behalf of such business entity and bind the business
                  entity to these Terms. The Account is deemed to be owned and controlled by the business
                  entity.
                </li>
                <p class="text-muted">
                  Additionally, you covenant and agree that you will not:
                </p>
                <li>
                  Impersonate any person or entity or misrepresent your affiliation with any person or
                  entity.
                </li>
                <li>
                  Engage in any activity that would create liability for us.
                </li>
                <li>
                  Attempt to remove, disable, circumvent, or otherwise create or implement any
                  workaround to any copy protection or security features in Deben.
                </li>
                <li>
                  Misuse Deben or do anything that may violate the integrity of the computer systems
                  relating to Deben or cause such system(s) to malfunction or stop their operation.
                </li>
                <li>
                  Attempt to gain unauthorized access to Deben, the server on which Deben is stored, or
                  any server, computer, or database connected to Deben.
                </li>
                <p class="text-muted">
                  You are responsible for configuring your information technology, computer programs, and
                  platform to access Deben and using your virus protection software. We will not be
                  responsible for any unauthorized access to your Account or your details through any type
                  of cyber-attack. We will endeavor to notify you if we become aware that Deben has been
                  compromised or attacked in accordance with our data protection obligations.
                </p>
                <p class="text-muted">
                  You acknowledge that Deben may contain technological copy protection or other security
                  features designed to prevent unauthorized use of Deben. You shall not attempt to remove,
                  disable, circumvent, or otherwise create or implement any workaround to any such copy
                  protection or security features.
                </p>
                <p class="text-muted">
                  We reserve the right to suspend your Account if there is a violation or suspected
                  violation of these Terms or if we have any other security concerns. In the event of any
                  breach of these obligations, we will report such breach to the relevant law enforcement
                  authorities and cooperate with those authorities by disclosing your identity to them.
                  Your right to use Deben will be terminated immediately in such an event.
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Linking Rules for Deben:
              </p>
              <p class="text-black">
                The following rules govern the practice of linking to Deben:
              </p>
              <p class="text-muted">
                You are permitted to link to the Deben homepage, provided that you have an Account, and that
                such linking is conducted in a manner that is fair, legal, and does not harm the reputation
                of Al Omla Al Hadesa (AOH) or exploit it in any way.
              </p>
              <p class="text-muted">
                You are prohibited from establishing a link in a manner that suggests any type of
                association, authorization, or endorsement by Deben where none exists.
              </p>
              <p class="text-muted">
                You are prohibited from establishing a link to Deben on any website that you do not own.
              </p>
              <p class="text-muted">
                Deben must not be framed on any other website, and you are not allowed to create a link to
                any part of Deben other than its homepage.
              </p>
              <p class="text-muted">
                We reserve the right to withdraw permission to link to Deben without prior notification.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Suspension and Termination:
              </p>
              <p class="text-muted">
                We reserve the right to suspend any or all services and access to Deben at its discretion,
                in the event of a technological malfunction, cyber-attack or threat, unauthorized access,
                events compromising its systems, or any other event that may impair its ability to maintain
                or operate Deben or cause a loss to users or Al Omla Al Hadesa (AOH).
              </p>
              <p class="text-muted">
                The provisions related to intellectual property, your responsibility for loss or damage
                suffered by us, confidentiality, miscellaneous, and governing law and complaints process
                will survive any termination of your relationship with Al Omla Al Hadesa (AOH) and continue
                to apply during any suspension. Additionally, any sections that, by their sense and context,
                should survive any termination of the agreement between you and Al Omla Al Hadesa (AOH)
                under these Terms will also continue to apply. You are prohibited from directly or
                indirectly accessing or using Deben upon suspension or termination.
              </p>
              <p class="text-muted">
                If you believe that your Account's termination or suspension was in error, please contact
                info&#64;deben.io.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Miscellaneous:
              </p>
              <p class="text-muted">
                You agree that these Terms, the Client Agreement, and the Privacy Policy are valid and
                enforceable, even if they were formed electronically.
              </p>
              <p class="text-muted">
                Deben is not in breach of these Terms if performance of its obligations is prevented by a
                force majeure event or other event outside of its reasonable control.
              </p>
              <p class="text-muted">
                By accepting these Terms, you agree that Deben may contact you by telephone, SMS, email, or
                mail for the purpose of administering these Terms.
              </p>
              <p class="text-muted">
                Deben may perform its obligations and exercise your rights under these Terms through a third
                party. Deben may also assign its rights and obligations under these Terms to a third party.
              </p>
              <p class="text-muted">
                These Terms, together with any Appendices/Annexes, Client Agreements, and the Privacy
                Policy, constitute the entire agreement between Deben and you. They supersede any prior or
                contemporaneous communications, representations, or agreements, whether oral or written.
              </p>
              <p class="text-muted">
                If any provision of these Terms is held to be invalid, illegal, or unenforceable, the
                remaining provisions will remain in full force and effect.
              </p>
              <p class="text-muted">
                If any provision of these Terms is held to be excessively broad, it will be construed to be
                limited to the extent necessary to make it enforceable.
              </p>
              <p class="text-muted">
                Deben's failure to exercise any right or remedy under these Terms does not waive that right
                or remedy.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Cookies Policy:
              </p>
              <p class="text-muted">
                Deben uses cookies to manage its website and improve visitors' experience. Cookies are small
                text files containing letters and numbers that are stored on visitors' devices when they
                access specific webpages. These cookies may be used to collect analytics related to
                non-personally identifiable visitor activity, manage personal preferences, provide relevant
                or timely information, or offer focused advertisements. Cookies that are set across Deben's
                website, whether set by third-party partners or by Deben itself, may be classified as
                session or persistent cookies and may leverage different technologies, such as JavaScript or
                Flash. Visitors have the option to opt out of cookies set by Deben's website and Deben on a
                cookie-by-cookie basis according to browser settings. However, limiting the use of cookies
                may restrict the operation or functionality of the website.
              </p>
              <p class="text-black">
                Governing Law and Dispute Resolution:
              </p>
              <p class="text-muted">
                These Terms, their subject matter, and their formation are governed by the applicable laws
                and regulations of the Kingdom of Saudi Arabia.
              </p>
              <p class="text-muted">
                For any concerns or queries related to Deben or its services, visitors may contact us at the
                email and number listed below. Al Omla Al Hadesa (AOH) is dedicated to providing visitors
                with a dedicated officer, or more, to process and resolve any complaints or issues in
                accordance with its Terms, Privacy Policy, Client Agreements, and the applicable laws and
                regulations of the Kingdom of Saudi Arabia.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                Contact Information:
              </p>
              <p class="text-black">
                Email: info&#64;deben.io
              </p>
              <p class="text-black">
                Number: +966 50 935 8075
              </p>
            </div>
          </div>
        </div>
      }

      <!-- Arabic T & C -->
      @if (_translate.currentLang == 'ar') {
        <div class="card" dir="rtl">
          <div class="bg-soft-warning position-relative">
            <div class="card-body p-5">
              <div class="text-center">
                <h3>الشروط والأحكام</h3>
                <p class="mb-0 text-muted">اخر تحديث 1 يونيو 2023</p>
              </div>
            </div>
            <div class="shape">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs" width="1440" height="60" preserveAspectRatio="none"
                viewBox="0 0 1440 60">
                <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                  <path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                  style="fill: var(--vz-card-bg-custom);"></path>
                </g>
                <defs>
                  <mask id="SvgjsMask1001">
                    <rect width="1440" height="60" fill="#ffffff"></rect>
                  </mask>
                </defs>
              </svg>
            </div>
          </div>
          <div class="card-body p-4">
            <div>
              <h5>شروط الاستخدام العامة</h5>
              <p class="text-decoration-underline fw-bold">مقدمة:</p>
              <p class="text-muted">
                شركة العملة الحديثة للتقنية المالية (العملة الحديثة)، شركة مسجلة في المملكة العربية السعودية
                مع سجل تجاري رقم 1010843917 (الشركة، نحن أو نحن)، تقدم ديبن كخدمة تمكن كيانات الأعمال من
                الاتصال والتكامل مع بنوكهم المختلفة للحصول على المعلومات المالية وأداء الخدمات الرقمية
                الأخرى.
              </p>
              <p class="text-muted">
                للاستفسارات، يرجى الاتصال بنا عبر البريد الإلكتروني: info&#64;deben.io أو الاتصال بنا على
                رقم
                هاتفنا: +966 50 935 8075.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">القبول والتأكيدات:</p>
              <p>
                باستخدامك ديبن، فإنك توافق على الشروط والأحكام التالية:
              </p>
              <ul class="text-muted vstack gap-2">
                <li>
                  لقد قرأت وفهمت ووافقت على الالتزام بشروط استخدام ديبن واتفاقية العميل وسياسة الخصوصية.
                </li>
                <li>
                  أنت توافق على تلقي المعلومات، بما في ذلك إشعارات التعديلات على هذه الشروط، من خلال
                  المراسلات المنشورة على ديبن أو غيرها من الوسائل على النحو المنصوص عليه في سياسة
                  الخصوصية.
                </li>
                <li>
                  يتمتع الشخص الذي يصل إلى ديبن باستخدام تفاصيل تسجيل الدخول ذات الصلة التي تم إنشاؤها
                  على ديبن لحسابك بالسلطة اللازمة للتصرف نيابة عن أي كيان قانوني تم إنشاء الحساب من أجله.
                </li>
                <li>
                  أنت توافق على تلقي الاتصالات وتسليم الشروط و / أو أي اتفاقيات بيننا أو تغييرات على
                  الشروط عبر الوسائط الإلكترونية، بما في ذلك الرسائل الإلكترونية، أو منشورات مواقع الويب،
                  أو البريد الإلكتروني، أو غيرها من الوسائل الإلكترونية.
                </li>
                <li>
                  أنت توافق على أن التسليم الإلكتروني للإشعارات والسياسات وسجلات المعاملات التي تم بدؤها
                  أو إكمالها من خلال ديبن و / أو فيما يتعلق بها، بالإضافة إلى أي توقيعات تم تمكينها
                  رقميًا، يجب أن يتم التعامل معها على أنها تلبي أي متطلبات قانونية يجب أن يكون الاتصال "
                  موقعة "و" كتابة. وبناءً على ذلك، فإن أي مستندات يتم تسليمها إليك إلكترونيًا تعتبر
                  "مكتوبة".
                </li>
                <li>
                  أنت تتنازل عن الحق في الادعاء بأن أي تأكيد إلكتروني أو اتفاق أو تحقق من الصحة أو تسجيل
                  غير صالح بسبب عدم وجود أي توقيع أو تصديق مادي.
                </li>
                <p class="text-black">
                  إذا كنت لا توافق على هذه الشروط والأحكام، فأنت غير مصرح لك باستخدام ديبن.
                </p>
              </ul>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                قابلية تطبيق سياسة الخصوصية واتفاقية العميل:
              </p>
              <ul class="text-muted vstack gap-2">
                <p>
                  بالإضافة إلى شروط الاستخدام، تنطبق الشروط الإضافية التالية على استخدامك لـ ديبن:
                </p>
                <li>
                  سياسة الخصوصية: تصف سياسة الخصوصية الخاصة بشركة ديبن كيف نعالج أي بيانات شخصية نجمعها
                  منك أو تزودنا بها. باستخدام ديبن، فإنك تقر وتوافق على سياسة الخصوصية وأنشطة المعالجة
                  الخاصة بنا، وأنت تقر وتضمن أن جميع البيانات التي تقدمها دقيقة.
                </li>
                <li>
                  اتفاقية العميل: تحدد اتفاقية العميل الشروط المطبقة على الخدمات المحددة المقدمة لك من
                  خلال ديبن من وقت لآخر. باستخدام ديبن، فإنك توافق على إخلاء المسؤولية في اتفاقية العميل،
                  وتقر باستلام المعلومات الرئيسية، وتوافق على استخدام ديبن وفقًا لهذه الشروط.
                </li>
              </ul>
              <p class="text-black">
                في حالة وجود أي تعارض بين الشروط وسياسة الخصوصية واتفاقية العميل، تسود أحكام اتفاقية العميل
                الخاصة بك.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                تعديل الشروط والأحكام:
              </p>
              <p class="text-muted">
                نحتفظ بالحق في تعديل هذه الشروط في أي وقت للامتثال للقوانين واللوائح المعمول بها، أو
                للترقيات التشغيلية أو التغييرات في ديبن. قد تتلقى إشعارًا بهذه التغييرات من خلال ديبن، أو
                عبر بريدك الإلكتروني المسجل، و / أو على ديبن قبل ثلاثين (30) يومًا على الأقل من تنفيذ هذه
                التغييرات.
              </p>
              <p class="text-muted">
                أنت تقر بأن أي إشعار بالتعديلات يتم إرساله إليك سوف يتم استلامه من تاريخ هذا الاتصال.
                باستخدام ديبن بعد تلقي إشعار بأي تعديلات على هذه الشروط، فإنك توافق على الالتزام بهذه
                التعديلات.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                الحق في تعديل الميزات أو إيقافها:
              </p>
              <p class="text-muted">
                نحتفظ بالحق في إضافة، أو تعديل، أو إيقاف أي ميزة، أو وظيفة، أو أداة ضمن ديبن وفقًا لتقديرها
                وبدون إشعار مسبق. ومع ذلك، إذا قمنا بإجراء أي تغيير سلبي جوهري على الميزات الأساسية لـ ديبن،
                فسنقوم بإخطار المستخدمين المسجلين عن طريق نشر إشعار على ديبن أو عن طريق البريد الإلكتروني.
              </p>
            </div>
            <div>
              <p class="text-decoration-underline fw-bold">
                الحق في التعليق أو السحب لـ ديبن:
              </p>
              <p class="text-muted">
                تبذل العملة الحديثة (العملة الحديثة)، كل جهد معقول لتقديم خدمات ها للمستخدمين. ومع ذلك، لا
                يمكننا أن نضمن أن خدماتها أو أي محتوى على نظامها الأساسي سيكون دائمًا متاحًا أو دون انقطاع
                أو خاليًا من الأخطاء. نحتفظ بالحق في تعليق، أو سحب، أو تقييد إتاحة كل، أو أي جزء من نظامها
                الأساسي لأسباب تجارية أو تشغيلية.
              </p>
              <p class="text-muted">
                في حالة قيام ديبن بتعليق خدماتها لفترة طويلة من الوقت أو سحب أي جزء من وظائفها الأساسية،
                فسنقدم إشعارًا للمستخدمين المسجلين من خلال إعلان يتم نشره على نظامها الأساسي أو عبر البريد
                الإلكتروني. لن يؤثر هذا التعليق أو الانسحاب على قدرة المستخدمين على ممارسة حقوقهم بموجب
                قوانين حماية البيانات المعمول بها كما هو منصوص عليه في سياسة الخصوصية الخاصة بـ ديبن.
              </p>
            </div>
          </div>
        </div>
      }
    </div><!--end col-->
  </div><!--end row-->
  <div class="p-3 text-center">
    <div class="text-center">
      <p class="mb-0 text-muted">&copy; {{year}} {{ 'COMMON.DEBEN' | translate }} {{
        'COMMON.All_RIGHTS_RESERVED' | translate }}
        <a routerLink="/terms-and-conditions" target=" _blank" rel="noopener"
          class="text-primary text-decoration-underline fs-14 fw-medium">
          {{'COMMON.TERMS_OF_USE' | translate}}
        </a>,
        <a routerLink="/privacy-policy" target="_blank" rel="noopener"
          class="text-primary text-decoration-underline fs-14 fw-medium">
          {{'COMMON.PRIVACY_POILICY' | translate}}
        </a>
      </p>
      <p class="mb-0 text-muted">
        {{'COMMON.PROTECTED_BY' | translate}} {{'COMMON.RECAPTCHA' | translate}}
        <span>{{'COMMON.TERMS_APPLY_AR' | translate}}</span>
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener"
          class="text-muted text-decoration-underline fs-14 fw-medium">
          {{'COMMON.GOOGLE_PRIVACY_POILICY' | translate}}
          </a> <span> {{'COMMON.AND' | translate}} </span>
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener"
            class="text-muted text-decoration-underline fs-14 fw-medium">
            {{'COMMON.TERMS_OF_SERVICE' | translate}}
          </a>
          <span>{{'COMMON.TERMS_APPLY_EN' | translate}}</span>
        </p>
      </div>
    </div>
  </div>